export const experienceData = [
    {
        id: 2,
        company: 'National Information Technology Development Agency',
        jobtitle: 'BackEnd Developer(Team Lead)',
        startYear: 'June 2025',
        endYear: 'November 2025'
    },
    {
        id: 3,
        company: 'SigNoz',
        jobtitle: 'Technical Writer',
        startYear: 'November 2024',
        endYear: 'March 2025'
    },
    {
        id: 4,
        company: 'RevolutionPlus',
        jobtitle: 'Backend Developer',
        startYear: 'February 2024',
        endYear: 'December 2024'
    },
    {
        id: 5,
        company: 'HIIT PLC',
        jobtitle: 'Backend Developer - Internship',
        startYear: 'August 2022',
        endYear: 'August 2023'
    },


]